<template>
  <div class="content_box">
    <div class="draggable-btn" ref="draggableBtn" @mousedown="startDrag">
      <p @click="setCurrent($event)">一键加购</p>
      <!-- <img src="@/assets/headerimage/yjjrcard.png" alt="拖拽按钮"> -->
    </div>
    <ArawerCard />
    <AppNewHeader :userName="userName" :placeholderText="'请输入数据库名称'" />

    <!-- Banner区域 -->
    <div class="dftsBanner"  v-loading="loading1">
      <div class="Banner">
        <div class="BannerImg">
          <img
            :style="
              detailsIss
                ? { width: '100%', height: '275px' }
                : { width: '100%', height: '555px' }
            "
            :src="bannerimg"
            alt=""
          />
          <div class="img_iext" v-if="detailsIss">
            <div>
              <span class="banner-text blue">定制化</span>
              <span class="banner-text black">地方特色数据库</span>
            </div>
            <div class="img_content">
              为地方图书馆提供解决方案，助力文旅融合与决策支持
            </div>
          </div>
          <div class="img_iext2" v-if="nameTltle === '公共图书馆'">
            <div>
              <!-- <span class="banner-text2">公共图书馆</span> -->
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 内容区域 -->
    <div
      v-loading="loading1"
      class="content_text"
      :style="detailsIss ? {} : { marginTop: '-123px' }"
      :class="{ 'overlap-banner': detailsIss }"
    >
      <div class="content_item">
        <div class="tableTitle" v-if="detailsIss">
          <img :src="dw01" alt="" />
          {{ nameTltle }}
        </div>

        <!-- 卡片列表 -->
        <div class="cardList">
          <div class="cardItem" v-for="(item, index) in tableData" :key="index">
            <div class="item">
              <div class="itemType">
                <div @click="handleClick(item)">
                  {{ item.title || "历近代史登科数据库" }}
                </div>
                <div>分类：{{ item.navi || "历史文化" }}</div>
              </div>
              <div class="item_content">
                <p v-html="item.description || defaultDescription"></p>
              </div>
              <div class="botList">
                <!-- <div class="botlist1">
                  <div class="netpire">
                    <span class="price-symbol">￥</span>
                    <span class="price-value">
                      <template v-if="item.netPrice20 && item.netPrice200">
                        {{ item.netPrice20 }} -
                        <span class="price-symbol">￥</span
                        >{{ item.netPrice200 }}
                      </template>
                      <template v-else-if="item.netPrice20">
                        {{ item.netPrice20 }}
                      </template>
                      <template v-else-if="item.netPrice200">
                        {{ item.netPrice200 }}
                      </template>
                      <template v-else> -- </template>
                    </span>
                    <span class="price-label">年使用费</span>
                  </div> -->
                <!-- <div class="price-divider"></div>
                  <div class="mirrpire">
                    <span class="price-symbol">￥</span>
                    <span class="price-value">{{
                      item.mirrorPrice || '--'
                    }}</span>
                    <span class="price-label">镜像访问</span>
                  </div> -->
                <!-- </div> -->
                <div class="but_item">
                  <div class="but_item1" @click="handleClick(item)">详情</div>
                  <div
                    class="but_item2"
                    @click="triggerParentEvent(item, $event)"
                  >
                    <img
                      style="height: !4px; width: 14px"
                      :src="imge0"
                      alt="采购图标"
                    />
                    <span style="padding-left: 4px">采购</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <el-footer>
      <AppFooter />
    </el-footer>
  </div>
</template>

<script setup>
import { ref, onMounted, onBeforeUnmount, onUnmounted,watch } from "vue";
import { useRouter, useRoute } from "vue-router";
import AppFooter from "@/views/components/AppFooter.vue";
import AppNewHeader from "@/views/components/AppNewHeader.vue";
import ArawerCard from "@/views/components/ArawerCard.vue";
import banner01 from "@/assets/headerimage/dftsBanner.png";
import banner02 from "@/assets/headerimage/banner02.png";
import banner03 from "@/assets/headerimage/banner03.png";
import banner04 from "@/assets/headerimage/banner04.png";
import banner05 from "@/assets/headerimage/banner05.png";
import dw01 from "@/assets/headerimage/dingwei.png";
import imge0 from "@/assets/headerimage/card002.png";
import bus from "@/mitt/bus.js";
import { ElMessage } from "element-plus";
import { Cookie } from "@/utils/Cookie";
import {
  PostUserCarList,
  PostProvienKnowList,
  PostBusInessKnmwList,
  getBuyLog,
} from "@/api/index.js";
import { usePageStayTime } from "@/utils/usePageStayTime";
const router = useRouter();
const route = useRoute();
const { stayTime, totalStayTimes } = usePageStayTime();
const loading1 = ref(true);
// 响应式数据
const detailsIss = ref(false);
const bannerimg = ref(banner01);
const tableData = ref([]);
const nameTltle = ref("");
const id2value = ref(route.query.id2 || "396");
const id1value = ref(route.query.id || "2");
const textValue = ref(route.query.name || '政府部门');
const defaultDescription = "暂无简介";
const weburl = ref(window.location.href);
const isDragging = ref(false);
const userName = ref("");

watch(
  () => route.query,
  (newQuery, oldQuery) => {
    if (oldQuery && (newQuery.id2 !== oldQuery.id2 || newQuery.name !== oldQuery.name)) {
      window.location.reload()
    }
  },
  { deep: true }
)
const checkTokenStatus = async () => {
  const token = JSON.parse(Cookie.get("token")) || "";
  if (token && !isTokenExpired(token)) {
    const userString = JSON.parse(Cookie.get("userInfo")) || null;
    const user = userString || null;
        userName.value = user?.realName;;
  }
};

const isTokenExpired = (token) => {
  try {
    const payload = JSON.parse(atob(token.split(".")[1]));
    if (payload.exp) {
      return Date.now() >= payload.exp * 1000;
    }
    return false; 
  } catch (e) {
    return true; 
  }
};
const handleLog = async () => {
  try {
    const res = await getBuyLog({
      type: "7",
      url: weburl.value,
      text: textValue.value,
      second: stayTime._value,
    });
    if (res) {
    }
  } catch (error) {
    console.log(error);
  }
};
const hiddenTime = ref(Number);

window.addEventListener("load", async () => {
  const stored = localStorage.getItem("lastSelectTime");
  hiddenTime.value = Math.floor((Date.now() - stored) / 1000);
  try {
    const res = await getBuyLog({
      type: "7",
      url: weburl.value,
      second: hiddenTime.value,
    });
    if (res.status == 200) {
      localStorage.setItem("lastSelectTime", Date.now().toString());
    }
  } catch (error) {
    console.log(error);
  }
});
// 初始化页面数据
onMounted(async () => {
 await checkTokenStatus();

  initializePageData();
  window.addEventListener("mousemove", onDrag);
  window.addEventListener("mouseup", stopDrag);
});
onBeforeUnmount(() => {
  window.removeEventListener("mousemove", onDrag);
  window.removeEventListener("mouseup", stopDrag);
});
onUnmounted(async () => {
  await handleLog();
});
// 页面数据初始化
const initializePageData = async () => {
  // loading1.value = true;
  try {
    if (route.query.id) {
      await fetchProvinceData(id1value.value);
      nameTltle.value = `${route.query.id}地方特色数据库`;
      bannerimg.value = banner01;
      detailsIss.value = true;
    } else if (route.query.id2) {
      await fetchBusinessData(id2value.value);
      nameTltle.value =textValue.value || "应用领域";
      detailsIss.value = false;
      updateBannerImage(nameTltle.value);
      loading1.value = false;
    }else{
      await fetchBusinessData(id2value.value);
      nameTltle.value =textValue.value || "应用领域";
      detailsIss.value = false;
      updateBannerImage(nameTltle.value);
      loading1.value = false;
    }
  } catch (error) {
    // loading1.value = true;
    console.error("初始化页面数据失败:", error);
  }
};

// 根据标题更新banner图片
const updateBannerImage = (title) => {
  const bannerMap = {
    政府部门: banner02,
    科研单位: banner03,
    公共图书馆: banner04,
    高校图书馆: banner05,
  };
  bannerimg.value = bannerMap[title] || banner01;
};

// 获取省份数据
const fetchProvinceData = async (id) => {
  loading1.value = true;
  const res = await PostProvienKnowList({ areaCode: id });
  if (res?.info) {
    tableData.value = res.info;
    loading1.value = false;
  }
};

// 获取业务数据
const fetchBusinessData = async (id) => {
  const res = await PostBusInessKnmwList({ bussinessCid: id });
  if (res?.info) {
    tableData.value = res.info;
  }
};

// 查看详情
const handleClick = (row) => {
  localStorage.setItem("lastSelectTime", Date.now().toString());
  if (!row?.id) return;
  router.push({
    path: "newDatabaseInfo",
    query: { id: row.id },
  });
};

// 触发父组件事件
const triggerParentEvent = (card, event) => {
  if (!card) return;
  bus.emit("sendMsg", {
    message: "Hello from SenderComponent!",
    card,
    event,
  });
};
const prepareCartData = () => {
  return tableData.value
    .filter((item) => item?.id)
    .map((item) => ({
      knowledgeId: item.id,
      knwoledgeTitle: item.title,
      publishUnit: item.publishUnit,
      knowledgeVersion: "netVersion",
      netVersion: item.netVersion,
      mirrorVersion: item.mirrorVersion,
      netPrice: item.netPrice,
      mirrorPrice: item.mirrorPrice,
      netPrice20: item.netPrice20,
      netPrice50: item.netPrice50,
      netPrice100: item.netPrice100,
      netPrice200: item.netPrice200,
    }));
};
const prepareCartData2 = () => {
  return tableData.value
    .filter((item) => item?.id)
    .map((item) => ({
      knowledgeId: item.id,
      id: item.id,
      knwoledgeTitle: item.title,
      publishUnit: item.publishUnit,
      knowledgeVersion: "netVersion",
      netVersion: item.netVersion,
      mirrorVersion: item.mirrorVersion,
      netPrice: item.netPrice,
      mirrorPrice: item.mirrorPrice,
      netPrice20: item.netPrice20,
      netPrice50: item.netPrice50,
      netPrice100: item.netPrice100,
      netPrice200: item.netPrice200,
    }));
};
// 一键加入购物车
const checkAuth = () => {
  const token = JSON.parse(Cookie.get("token")) || "";
  if (!token || isTokenExpired(token)) {
    ElMessage.warning("请先登录");
    router.push("/login");
    return false;
  }
  return true;
};

const setCurrent = async (event) => {
  // 检查是否正在进行拖拽，如果正在拖拽则不执行点击事件
  if (isDragging.value) return;

  try {
    // First check token status
    const token = JSON.parse(Cookie.get("token")) || "";
    // if (!token || isTokenExpired(token)) {
    //   ElMessage.warning("请先登录");
    //   // router.push("/login"); // Redirect to login page
    //   return;
    // }

    const selectedData = prepareCartData();
    if (selectedData.length === 0) return;

    const response = await PostUserCarList({ cart: selectedData });
    if (response.success) {
      ElMessage.success("一键加入成功");
      triggerParentEvent(prepareCartData(), event);
    }
  } catch (error) {
    console.error("加入购物车失败:", error);
    if (error.response && error.response.status === 401) {
      ElMessage.warning("登录已过期，请重新登录");
      // router.push("/login");
    } else {
      // console.log( prepareCartData());

      localStorage.setItem(
        "addCardListParams",
        JSON.stringify(prepareCartData2())
      );
      triggerParentEvent(prepareCartData2(), event);
      ElMessage.success(`${prepareCartData2().length}个项目已添加到购物车`);
    }
  }
};

const draggableBtn = ref(null);
let offsetX = 0;
let offsetY = 0;

const startDrag = (e) => {
  isDragging.value = true;
  const rect = draggableBtn.value.getBoundingClientRect();
  offsetX = e.clientX - rect.left;
  offsetY = e.clientY - rect.top;

  // 防止文本选中
  document.body.style.userSelect = "none";
};

const onDrag = (e) => {
  if (!isDragging.value) return;

  const windowWidth = window.innerWidth;
  const windowHeight = window.innerHeight;
  const btnWidth = draggableBtn.value.offsetWidth;
  const btnHeight = draggableBtn.value.offsetHeight;

  let newX = e.clientX - offsetX;
  let newY = e.clientY - offsetY;

  // 限制X轴位置
  if (newX < 0) {
    newX = 0;
  } else if (newX > windowWidth - btnWidth) {
    newX = windowWidth - btnWidth;
  }

  // 限制Y轴位置
  if (newY < 0) {
    newY = 0;
  } else if (newY > windowHeight - btnHeight) {
    newY = windowHeight - btnHeight;
  }

  draggableBtn.value.style.left = `${newX}px`;
  draggableBtn.value.style.top = `${newY}px`;
};

const stopDrag = () => {
  isDragging.value = false;
  document.body.style.userSelect = "";
};

const handleDragEnd = (e) => {
  e.target.style.opacity = "1";
  // 获取最终位置
  const x = e.clientX;
  const y = e.clientY;
  console.log(`按钮被拖拽到位置: (${x}, ${y})`);
};
</script>

<style scoped>
/* 原有样式全部保留 */
.content_box {
  background: #f5f5f5;
}
.el-footer {
  --el-footer-padding: 0;
  --el-footer-height: 0;
  box-sizing: border-box;
  flex-shrink: 0;
  height: var(--el-footer-height);
  padding: var(--el-footer-padding);
}
.content_text {
  width: 100%;
  display: flex;
  justify-content: center;
  background: #f5f5f5;
}
.content_item {
  width: 1400px;
  min-height: 750px;
  z-index: 2;
}
.tableTitle {
  /* height: 57px; */
  /* line-height: 57px; */
  font-family: PingFangSC, PingFang SC;
  font-weight: 600;
  font-size: 18px;
  color: #333333;
  text-align: left;
  font-style: normal;
  margin: 40px 0 15px 0;
}
.tableTitle > img {
  width: 16px;
  height: 16px;
}
.dftsBanner {
  width: 100%;
  height: 276px;
}
.BannerImg {
  width: 100%;
  height: 276px;
  position: relative;
}
.img_iext {
  position: absolute;
  left: 346px;
  top: 90px;
}
.img_iext2 {
  position: absolute;
  left: 873px;
  top: 59px;
}
.banner-text2 {
  font-weight: normal;
  font-size: 34px;
  color: #139bad;
  font-style: normal;
}
.img_content {
  font-family: SourceHanSansSC, SourceHanSansSC;
  font-weight: 400;
  font-size: 20px;
  color: #707070;
  line-height: 29px;
  text-align: left;
  font-style: normal;
}
.cardList {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 12px;
  margin-bottom: 30px;
}
.item {
  width: 694px;
  height: 150px;
  background: #ffffff;
  /* border-radius: 6px; */
}
.itemType {
  display: flex;
  justify-content: space-between;
  padding: 16px 22px 8px 16px;
}
.item_content > p {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  height: 40px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 14px;
  color: #999999;
  line-height: 20px;
  text-align: justify;
  font-style: normal;
  padding: 0px 22px 0px 16px;
  margin: 0;
}
.botList {
  display: flex;
  justify-content: space-between;
  padding: 20px 16px 0px 16px;
}
.botlist1 {
  display: flex;
  justify-content: space-between;
}
.but_item {
  display: flex;
  justify-content: space-between;
}
.but_item1 {
  width: 78px;
  height: 30px;
  background: rgba(255, 255, 255, 0);
  /* border-radius: 4px; */
  border: 1px solid #2c77ff;
  line-height: 30px;
  text-align: center;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 14px;
  color: #2c77ff;
  font-style: normal;
  cursor: pointer;
}
.but_item1:hover {
  background: #2c77ff;
  color: #fff;
}
.but_item2 {
  width: 78px;
  height: 32px;
  background: #2c77ff;
  /* border-radius: 4px; */
  line-height: 32px;
  text-align: center;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 14px;
  color: #ffffff;
  font-style: normal;
  margin-left: 10px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
.but_item2:hover {
  background: #2565d9;
}
.itemType > div:nth-child(1) {
  font-family: PingFangSC;
  font-weight: 500;
  font-size: 16px;
  color: #333333;
  text-align: left;
  font-style: normal;
  cursor: pointer;
}
.itemType > div:nth-child(1):hover {
  color: #2c77ff;
}
.itemType > div:nth-child(2) {
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 12px;
  color: #999999;
  text-align: center;
  font-style: normal;
}
.mirrpire {
  margin-left: 10px;
}
.price-divider {
  width: 17px;
  height: 12px;
  border-right: 1px solid rgb(235, 235, 235);
  margin-top: 10px;
}

/* 新增样式 - 不影响原有样式 */
.overlap-banner {
  position: relative;
  z-index: 1;
  margin-top: -20px; /* 根据需要调整这个值 */
}

.banner-text {
  font-family: SourceHanSansSC, SourceHanSansSC;
  font-weight: bold;
  font-size: 40px;
  line-height: 59px;
  text-align: left;
  font-style: normal;
}
.blue {
  color: #1568ff;
}
.black {
  color: #383838;
}
.price-symbol {
  font-family: PingFangSC, PingFang SC;
  font-weight: 500;
  font-size: 13px;
  color: #fe5c5c;
  line-height: 25px;
}
.price-value {
  font-family: PingFangSC, PingFang SC;
  font-weight: 500;
  font-size: 18px;
  color: #fe5c5c;
  line-height: 25px;
  text-align: left;
  font-style: normal;
}
.price-label {
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 12px;
  color: #999999;
  line-height: 17px;
  text-align: left;
  font-style: normal;
  padding-left: 5px;
}

.draggable-btn {
  position: fixed;
  right: 30px;
  bottom: 400px;
  width: 226px;
  height: 107px;
  /* border-radius: 50%; */
  /* background-color: #2c77ff; */
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: move;
  /* box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2); */
  z-index: 1000;
  transition: opacity 0.3s;
  background-image: url(@/assets/headerimage/yjjrcard01.png);
  background-size: cover;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 15px;
  color: #333333;
  line-height: 21px;
  text-align: center;
  font-style: normal;
  /* cursor: pointer; */
}
.draggable-btn p {
  font-size: 15px;
  color: #333333;
  width: 78px;
  margin-left: 50px;
  cursor: pointer;
}
.draggable-btn :hover {
  color: #2c77ff;
}
</style>
